<template>
  <div class="brief-usuarios">
    <b-card header= "Usuarios" class="brief-header">
      <b-btn class="btn-collapse-card" 
          variant="primary" 
          size="sm"
          @click.prevent="showUsuarios= !showUsuarios">
        <i :class="showUsuarios ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="headerUsuarios" class="mt-2" v-model="showUsuarios">
        <b-row>
          <b-col>
            <b-form-group
              label="Creado por"
              label-for="usuario"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="usuario"
                :value="usuario"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Responsable"
              label-for="responsable"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="responsable"
                :value="responsable"
                readonly
                type="text"/>
            </b-form-group>

            <b-table hover
                responsive="sm" 
                class="registro"
                :items="usuarios" 
                :fields="usuariosFields">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>
              <template v-slot:cell(usuario)="data">
                {{ data.item.usuario.trim() + ' - ' + data.item.usuarioRol.trim() }}
              </template>
              <template v-slot:cell(asignado)="data">
                <b-form-checkbox
                    v-model="data.item.asignado"
                    :disabled="data.item.inactivo"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                </b-form-checkbox> 
              </template>
            </b-table>

          </b-col>
        </b-row>
      </b-collapse>
    </b-card>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { mapState } from 'vuex';

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'brief/getField',
  mutationType: 'brief/updateField',
});

export default {
  name: 'BriefUsuarios',
  components: {
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal
  ],
  data () {
    return {
      usuariosFields: [
        {
          key: 'usuario',
          label: 'Usuarios',
        },
        {
          key: 'asignado',
          label: '',
          class: 'text-center'
        },
      ],

      showUsuarios: false,

      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'usuario',
      'responsable',
      'usuarios',
    ]),
  },  
  created() {
  },
  destroyed() {
  },
  methods: {
  },
  watch: {
  }    
}
</script>

<style>
  .brief-usuarios .registro {
    margin-top: 30px;    
  }
  .brief-usuarios table thead th {
    border-top: none;
  }
  .brief-usuarios table tr.table-inactivo {
    color: #a9a9a9;
  }
</style>